import axios from 'axios';
import AuthService from '../auth/AuthService';
import { BASE_URL } from './endpoints';

const axiosClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Accept': 'application/json',
  }
});

axiosClient.interceptors.request.use(
  (config) => {
    const token = AuthService.getToken();
    if (token) {
      config.headers['Authorization'] = `Token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Clear local auth state and redirect to login when the backend invalidates
// our token. Runs once per 401 so parallel requests don't stack redirects.
let isRedirectingOn401 = false;

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const isAlreadyOnLogin = window.location.pathname.startsWith('/acc/login');

    if (status === 401 && !isRedirectingOn401 && !isAlreadyOnLogin) {
      isRedirectingOn401 = true;
      AuthService.clearToken();
      AuthService.clearUser();
      // Drop any in-progress tour so it doesn't rehydrate on the login
      // page after the redirect (the inactivity-timer logout path in
      // useAuth.js already does this; mirror it here).
      sessionStorage.removeItem('onboardingTourStep');
      sessionStorage.removeItem('onboardingTourActive');
      sessionStorage.removeItem('onboardingTourName');
      sessionStorage.removeItem('onboardingTourGameId');
      window.location.href = '/acc/login?expired=1';
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
